import Notes from '@magoosh/gre/adaptive_prep_v2/pages/notes';
import SegmentDetail from '@magoosh/gre/adaptive_prep_v2/pages/segment_detail';
import StudyPlan from '@magoosh/gre/adaptive_prep_v2/pages/study_plan';
import TopicOverview from '@magoosh/gre/adaptive_prep_v2/pages/topic_overview';
import YourClasses from '@magoosh/pages/live_classes/all_classes';

// Declaring and exporting routes in this way allows our <ContextualLink> component to render
// a <Link> if a route is handled by the SPA or a plan <a> if not.
const routes = [
  {
    path: '/dashboard/:tab?',
    component: StudyPlan
  },
  {
    path: '/learn/:segmentId',
    component: SegmentDetail
  },
  {
    path: '/topics/:sectionName?',
    component: TopicOverview
  },
  {
    path: '/notes/:sectionName?',
    component: Notes
  },
  {
    path: '/live_classes',
    component: YourClasses
  }
];

export default routes;
